var _mask, _g, _mask2, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgLogoIti = function SvgLogoIti(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 67,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "logo-iti_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 51
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0h49.225v50.996H0V0z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-iti_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.414 5.394C9.418 2.885 7.373.975 4.689.982 2 .99-.018 2.903 0 5.426c.018 2.47 2.035 4.362 4.678 4.388 2.644.026 4.731-1.922 4.736-4.42zm30.399-.048c-.02 2.514 2.01 4.448 4.686 4.468 2.647.02 4.728-1.93 4.728-4.43 0-2.475-2.01-4.38-4.643-4.401-2.704-.022-4.752 1.851-4.771 4.363zM35.11 23.38H22.765v13.855c.003.735.087 1.482.229 2.203.494 2.505 2.048 4.018 4.47 4.45.499.09 1.008.102 1.515.102 3.653 0 6.13-1.013 6.13-1.013v6.648c-4.637 1.463-8.765 1.727-13.32-.318-3.595-1.613-5.393-4.606-6.081-8.257-.256-1.36-.352-2.761-.367-4.145l-.017-19.507v-6.056c0-3.237 2.713-5.862 6.059-5.862h1.382v11.844H35.11v6.056zM8.407 17.324h-.072c-3.94 0-7.132 3.09-7.132 6.9v25.48h7.204v-32.38zm39.801 32.38V24.288c0-3.845-3.222-6.963-7.197-6.963h-.072v32.377h7.27z",
    fill: "url(#logo-iti_svg__paint0_linear)"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "logo-iti_svg__b",
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 57,
    width: 19,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.56 57.185h17.867v8.853H29.559v-8.853z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-iti_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.157 59.007h1.246l1.52-1.822H45.38l-1.223 1.822zM42.92 65.39c.361.432.847.648 1.457.648.365 0 .699-.074 1-.222a1.88 1.88 0 00.738-.642l.08.712h1.234v-6.061H46.01v3.609c0 .428-.104.77-.314 1.027-.21.258-.486.386-.829.386-.343 0-.607-.123-.794-.368-.187-.245-.28-.597-.28-1.057v-3.597h-1.418v3.83c0 .725.181 1.303.544 1.735zm-4.236-.38c.35 0 .65-.128.897-.385.248-.257.372-.568.372-.935v-.595c-.076 0-.155-.002-.234-.006a4.803 4.803 0 00-.246-.006c-.564 0-.996.088-1.298.263-.3.175-.451.43-.451.765 0 .273.087.49.263.654.175.163.407.245.697.245zm-1.785.55c.35.319.815.478 1.395.478a2.26 2.26 0 001.011-.228 1.89 1.89 0 00.738-.625l.08.701h1.177v-3.62c0-.833-.217-1.474-.651-1.922-.435-.447-1.052-.671-1.853-.671a4.03 4.03 0 00-1.909.49v1.168c.564-.327 1.128-.49 1.692-.49.442 0 .774.105.995.315.22.21.343.533.366.97a2.45 2.45 0 00-.24-.012h-.252c-.983 0-1.742.189-2.275.566-.533.378-.8.91-.8 1.594 0 .538.175.966.526 1.285zm-2.091.443c-.64 0-1.124-.173-1.452-.52-.328-.346-.492-.862-.492-1.547v-2.99h-.937v-1.122h.937v-1.612h1.418v1.612h1.326v1.122h-1.326v2.861c0 .35.069.61.206.777.137.167.35.251.64.251.221 0 .434-.047.64-.14v1.133a2.722 2.722 0 01-.96.175zm-3.785-.117h-1.463v-7.884h1.463v7.884z",
    fill: "#FC4E75"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo-iti_svg__paint0_linear",
    x1: -24.613,
    y1: 25.882,
    x2: 25.184,
    y2: 75.106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E96401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD4D7C"
  })))));
};

export default SvgLogoIti;